var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_963_724)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.754,
    cy: 75.8058,
    r: 16.2596,
    transform: "rotate(-4.74173 59.754 75.8058)",
    stroke: "#ACACAC",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1478 53.2277L62.5489 52.4479L64.5216 61.9652L52.7702 62.94L53.1478 53.2277Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.745,
    cy: 50.3298,
    r: 16.2596,
    transform: "rotate(-65.388 111.745 50.3298)",
    stroke: "#ACACAC",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.827 45.0198L92.7558 36.4434L102.018 39.3894L97.1072 50.1098L88.827 45.0198Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5645,
    y: 50.4912,
    width: 11.593,
    height: 5.79648,
    rx: 2.89824,
    transform: "rotate(-90.6863 54.5645 50.4912)",
    stroke: "#ACACAC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1758,
    y: 33.5947,
    width: 11.593,
    height: 5.79648,
    rx: 2.89824,
    transform: "rotate(-53.605 55.1758 33.5947)",
    stroke: "#ACACAC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.4043,
    y: 23.0625,
    width: 11.593,
    height: 5.79648,
    rx: 2.89824,
    transform: "rotate(10.2898 69.4043 23.0625)",
    stroke: "#ACACAC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2656,
    y: 29.0605,
    width: 11.593,
    height: 5.79648,
    rx: 2.89824,
    transform: "rotate(79.6257 87.2656 29.0605)",
    stroke: "#ACACAC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.943 45.8364C57.933 45.5604 57.7012 45.3448 57.4252 45.3548C57.1493 45.3648 56.9337 45.5967 56.9437 45.8726L57.943 45.8364ZM56.9437 45.8726L57.2045 53.0645L58.2038 53.0282L57.943 45.8364L56.9437 45.8726Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1016 32.6592L57.5743 39.6919",
    stroke: "#ACACAC",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6191 25.4619L63.572 26.921",
    stroke: "#ACACAC",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0215 30.5479L77.9643 26.6618",
    stroke: "#ACACAC",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8027 40.668L86.3624 37.4566",
    stroke: "#ACACAC",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_963_724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChain);
export default __webpack_public_path__ + "static/media/IcChain.2bc6431871b1606d5f07f43e093ce87b.svg";
export { ForwardRef as ReactComponent };